import { api } from './cliente';
import type { EntradaChangelog } from '../../shared/changelog';

/**
 * O que mudou no app, e o que esta pessoa ainda não viu.
 *
 * A lista completa vive no pacote compartilhado — é código, não conteúdo de
 * banco. O que só o servidor sabe é `nao_vistas`, que depende de
 * `usuarios.changelog_visto_em`.
 */
export const changelogQuery = {
  queryKey: ['changelog'] as const,
  queryFn: () => api.get<{ entradas: EntradaChangelog[]; nao_vistas: string[] }>('/changelog'),
  staleTime: 5 * 60 * 1000,
};

export const marcarNovidadesVistas = () => api.post('/changelog/visto');
